<template>
	<div class="filters-box">
		<div class="filters-box-row">
			<div class="data-picker-box">
				<span>时间周期：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					align="right"
					:clearable='false'
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<!-- <div class="business-name-box">
				<span>采购门店名称：</span>
				<el-input v-model="businessNameValue" placeholder="请输入供货商" class="business-name-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div> -->
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			businessNameValue: '',
			dateValue: []
		}
	},
	created () {
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
	},
	methods: {
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59`, 'op': 'le' }
				]
			} else {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.dateValue[1]} 23:59`, 'op': 'le' }
				]
			}
			if (this.businessNameValue) {
				let businessName = { field: 'entname', data: this.businessNameValue, 'op': 'cn' }
				filtersParams.push(businessName)
			}
			return {
				filtersParams,
				cParams
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]} 00:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]} 23:59`, 'op': 'le', type: 'filtersParams' }
			]
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	.filters-box-row {
		display: flex
		margin-bottom: 10px
		&:last-child {
			margin-bottom: 0px
		}
		.order-type-box {
			margin-right: 300px
			.order-type-select {
				width: 150px
			}
		}
		.business-name-box {
			.business-name-input {
				width: 150px
			}
		}
		.data-picker-box{
			margin-right: 100px
		}
		.shops-sum-box{
			.shops-sum-input{
				width: 150px
			}
		}
	}
}
</style>

